var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .276h19.085v1.701H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.005)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA2AA",
    d: "M18.234 1.977H.85a.85.85 0 0 1 0-1.7h17.384a.85.85 0 1 1 0 1.7",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA2AA",
    d: "M6.61 4.281h6.235V2.397a.697.697 0 0 0-.696-.696H7.307a.697.697 0 0 0-.696.696v1.884zm7.937 1.701H4.91V2.397A2.4 2.4 0 0 1 7.307 0h4.842a2.4 2.4 0 0 1 2.398 2.397v3.585zM14.592 20.005H4.694a2.584 2.584 0 0 1-2.581-2.581v-9.24a.85.85 0 1 1 1.7 0v9.24c0 .485.395.88.88.88h9.899a.88.88 0 0 0 .879-.88v-9.24a.851.851 0 1 1 1.702 0v9.24a2.584 2.584 0 0 1-2.581 2.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA2AA",
    d: "M7.759 16.22a.851.851 0 0 1-.851-.852v-5.095a.851.851 0 1 1 1.702 0v5.095c0 .47-.381.851-.851.851M11.526 16.22a.851.851 0 0 1-.85-.852v-5.095a.851.851 0 1 1 1.701 0v5.095c0 .47-.38.851-.85.851"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.abb26cde92d58ee7fa48f73d318fc8d9.svg";
export { ForwardRef as ReactComponent };